import { isSingleChat } from './ChatHelper';
import { CHAT_TYPE_GROUP, CHAT_TYPE_SINGLE } from './Constant';
import { store } from '../../Redux/store';
import SDK from '../../SDK';
import _get from "lodash-es/get";
import { getFormatPhoneNumber } from '../Utility';
import { addNewRosterAction } from '../../Redux/feature/rosterDataSlice';
const requestUserids = [];

export const formatUserIdToJid = (userId, chatType = CHAT_TYPE_SINGLE) => {
    const jidResponse = chatType === CHAT_TYPE_SINGLE ? SDK.getJid(userId) : SDK.getGroupJid(userId)
    if (jidResponse.statusCode === 200) {
        return jidResponse.userJid || jidResponse.groupJid
    }
}

export const getUserNickName = (userObj) => {
    return userObj?.nickName || userObj?.userProfile?.nickName;
}

export const isDisplayNickName = (userObj) => {
    return !isLocalUser(userObj.userId) && !userObj.isFriend;
}

export const getGroupNameFromRoster = (roster) => {
    if (!roster || typeof roster != "object") return roster;
    return roster.groupName || roster.groupId;
}

export const getFriendsFromRosters = (rosters) => {
    if (!rosters || !Array.isArray(rosters)) return rosters;
    return rosters.filter((user) => user.isFriend);
}


export const getContactNameFromRoster = (roster) => {
    if (!roster || typeof roster != "object") return roster;
    if (roster.groupId) {
        return getGroupNameFromRoster(roster);
    }
    return roster.nickName || getFormatPhoneNumber(roster.mobileNumber) || roster.name;
}

export const getUserInfoForSearch = (roster) => {
    if (!roster || typeof roster != "object") return roster;
    const fieldsForSearch = ['nickName', 'groupName'];
    const userInfo = [];
    fieldsForSearch.forEach(field => roster[field] && userInfo.push(roster[field]))
    return userInfo;
}

export const addVcardDataToRoster = (userObj) => {
    if (!userObj || typeof userObj !== 'object') return;
    if (userObj.userId && !userObj.userJid) {
        userObj['userJid'] = formatUserIdToJid(userObj.userId);
    }
    store.dispatch(addNewRosterAction({ ...userObj, isFriend: false }));
}

export const getDataFromRoster = (userId) => {
    const currentState = store.getState()
    let {
        rosterData: {
            rosterNames
        }
    } = currentState
    if (rosterNames instanceof Map) {
        if (!rosterNames || !rosterNames.has(userId)) {
            if (userId) {
                getDataFromSDK(userId);
            }
            let data = { userId: userId, userJid: formatUserIdToJid(userId) };
            return data;
        } else {
            return rosterNames.get(userId);
        }
    }
    return {};
}

export const getDataFromSDK = async (userId) => {
    let data = { userId: userId, userJid: formatUserIdToJid(userId) };
    if (!requestUserids.includes(userId)) {
        requestUserids.push(userId);
        const profileDetailsResponse = await SDK.getUserProfile(formatUserIdToJid(userId));
        let index = requestUserids.indexOf(userId);
        if (index !== -1) {
            requestUserids.splice(index, 1);
        }
        if (profileDetailsResponse.statusCode === 200) {
            const userProfileDetails = { ...profileDetailsResponse.data };
            userProfileDetails.name = userProfileDetails.nickName;
            data = {
                ...data,
                ...userProfileDetails,
            };
            addVcardDataToRoster(data);
        } else {
            data = {
                ...data,
                isDeletedUser: true,
                email: "",
                image: "",
                thumbImage: "",
                isAdminBlocked: false,
                isFriend: false,
                mobileNumber: "",
                name: "Deleted User",
                nickName: "Deleted User",
                displayName: "Deleted User",
                status: ""
            }
            addVcardDataToRoster(data);
        }
        return data;
    }
    return data;
}

export const getLocalUserDetails = () => {
    const vCardData = store.getState().vCardData;
    return vCardData?.data;
}

export const isSingleChatJID = (jid) => {
    return !(jid.includes(`mix`));
    // // if (jid.includes(`mix`)) return false;
    // // return true;
}

/**
 * Return the ID(userId or groupId) from given jid(userJid or groupdJid)
 * @param {*} jid 
 */
export const getIdFromJid = (jid) => {
    if (!jid) return jid;
    return jid.split('@')[0];
}

/**
 * Check the given user is local or not
 * @param {*} userId 
 */
export const isLocalUser = (userId = "") => {
    if (!userId) return false;
    userId = getIdFromJid(userId);
    const vCardData = store.getState().vCardData;
    return userId === vCardData?.data?.fromUser;
};

export const initialNameHandle = (roster = {}, name = "") => {
    if (isLocalUser(roster.fromUser)) return name;
    let imageUrl = _get(roster, "image", "");
    if (imageUrl === "") {
        return name
    }
    return "";
}

/**
 * Return the user Id from given message object based on the chat type
 * Onetoone chat userId will contain by fromUserId
 * Group chat userId will contain by publisherId
 * @param {*} msgObj 
 */
export const getSenderIdFromMsgObj = (msgObj) => {
    if (!msgObj || typeof msgObj != 'object') return "";
    const { fromUserId, publisherId } = msgObj;
    return isSingleChat(msgObj.chatType) ? fromUserId : publisherId;
}

export const formatGroupIdToJid = (groupId) => {
    if (!groupId || groupId.includes(`mix`)) return groupId;
    return formatUserIdToJid(groupId, CHAT_TYPE_GROUP);
}


export const getUserDetails = (userJid = "") => {
    let rosterData = {};
    let user = userJid.includes("@") ? userJid.split('@')[0] : userJid;
    let vcardData = getLocalUserDetails() || {};
    if (user === vcardData?.fromUser) {
        rosterData.displayName = "You";
        rosterData.isFriend = true;
        rosterData.image = vcardData.image;
        rosterData.thumbImage = vcardData.thumbImage;
        rosterData.jid = user;
        rosterData.chatType = "chat";
        rosterData.initialName = vcardData.nickName;
    } else {
        let userDetails = getDataFromRoster(user);
        let { isAdminBlocked, image, thumbImage } = userDetails;
        if (Object.keys(userDetails).length > 0) {
            rosterData = { ...userDetails };
            rosterData.displayName = getContactNameFromRoster(userDetails);
            rosterData.image = isAdminBlocked ? "" : image;
            rosterData.thumbImage = isAdminBlocked ? "" : thumbImage;
            rosterData.chatType = "chat";
            rosterData.initialName = rosterData.displayName;
            rosterData.isAdminBlocked = userDetails.isAdminBlocked
        } else {
            rosterData.displayName = getFormatPhoneNumber(user);
            rosterData.initialName = "";
            rosterData.image = "";
            rosterData.thumbImage = "";
            rosterData.jid = user;
            rosterData.chatType = "chat";
            rosterData.userColor = "";
            rosterData.userId = user;
            rosterData.userJid = formatUserIdToJid(user);
            rosterData.isAdminBlocked = userDetails.isAdminBlocked
        }
    }
    return rosterData;
}

export const formatDisplayName = (messageFrom = "") => {
    const userPhoneNumber = messageFrom.split('@')[0]
    const rosterObject = getDataFromRoster(messageFrom)
    if (!rosterObject) {
        return {
            nameToDisplay: getFormatPhoneNumber(userPhoneNumber),
            userColor: 'black'
        };
    }
    const { userColor } = rosterObject || {}
    const nameToDisplay = getContactNameFromRoster(rosterObject);
    return {
        nameToDisplay,
        userColor
    }
}

export const constructRosterData = async (userJid) => {
    const profileData = await SDK.getUserProfile(userJid)
    if (profileData && profileData.statusCode === 200) {
        return {
            email: profileData.data.email,
            image: profileData.data.image,
            isAdminBlocked: 0,
            isDeletedUser: false,
            isFriend: true,
            mobileNumber: profileData.data.mobileNumber,
            name: profileData.nickName,
            nickName: profileData.data.nickName,
            status: profileData.data.status,
            userColor: "",
            thumbImage: profileData.data.thumbImage,
            userId: profileData.data.userId,
            userJid: userJid,
        }
    }
}
